module.exports = __webpack_public_path__ + "img/10_1.b9dd3015.png";